import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { TipoMaquina } from '../../types/producao';
import { tiposMaquinaService } from '../../services';

const fields: ResourceField<TipoMaquina>[] = [
  { name: 'codigo', label: 'Código', required: true },
  { name: 'descricao', label: 'Descrição', required: true },
];

export const TiposMaquinaFormPage: React.FC = () => (
  <ResourceFormPage
    title="Tipo de máquina"
    description="Cadastre ou edite tipos de máquina."
    fields={fields}
    service={tiposMaquinaService}
    redirectPath="/admin/producao/tipos-maquina"
    cancelPath="/admin/producao/tipos-maquina"
  />
);
